import { createAction, createReducer } from "@reduxjs/toolkit";

export const updateToken = createAction("updateToken");
export const updateIdentity = createAction("updateIdentity");
export const updateSelectedClient = createAction("updateSelectedClient");

// let lastId = 0;

// Identity Object from Login.js
// const identity = {
//   authToken: authToken,
//   clients: JSON.stringify(clientList),
//   selectedClient: JSON.stringify(clientList[0]),
//   roles: json.roles,
//   isActivated: json.isActivated,
//   userId: json.userId,
//   userName: json.userName,
//   userPhone: json.userPhone,
//   email: json.email ? json.email : "not available",
//   twoStepRequired: json.twoStepRequired,
// };

const initialState = {
  token: "",
  identity: {},
  selectedClient: {}
}

export default createReducer(initialState, {
  [updateToken.type]: (state, action) => {
    state.token = action.payload.description
  },
  [updateIdentity.type]: (state, action) => {
    state.identity = action.payload.description
  },
  [updateSelectedClient.type]: (state, action) => {
    state.selectedClient = action.payload.description
  }
});



